export default __webpack_public_path__ + "static/media/PurchaseLinkIndicatorSummaryActive.bdb03e77.svg";